import './App.css?v=2';
import { useEffect, useState } from 'react';

import {
    Box
} from '@chakra-ui/react';

import { Content } from './components/Content.jsx';

import { MISC } from './helpers/misc.js'

function App() {
	const [initialEventConfig, setinitialEventConfig] = useState(false)

	//UPDATE IF CONFIG NEEDS RELOADED
	const configVersion = "8";

	const loadEventConfig = async () => {
		const newEventConfig = await MISC.fetchJson(`config/config.json?v=${configVersion}`);

		newEventConfig["startDate"] = `${newEventConfig["eventDates"][0]["date"]} ${newEventConfig["eventDates"][0]["start"]}`;

		setinitialEventConfig({...newEventConfig});

		document.title = newEventConfig["liveLong"]
	}

	const ContentLoader = () => {
		if (initialEventConfig) {
			return <Content configVersion={configVersion} initialEventConfig={initialEventConfig}/>
		}

		return ([]);
	}

	useEffect(()=>{
		loadEventConfig();
	}, [])

	return (
		<Box>
			<ContentLoader/>
		</Box>
	);
}

export default App;
